/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshInstrumentSyncEntitiesRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/RefreshInstrumentSyncEntities.pb'
import {RefreshInstrumentSyncEntitiesResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/RefreshInstrumentSyncEntities.pb'


export const refreshInstrumentSyncEntities = (request: RefreshInstrumentSyncEntitiesRequest, options?: CashRequestOptions) => post<RefreshInstrumentSyncEntitiesRequest, RefreshInstrumentSyncEntitiesResponse>("/2.0/cash/refresh-instrument-sync-entities", request, {...options, rejectOnError: true })